import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import documentos from "../../json/documentos";
import "./styles.css";

const DocumentoDinamico = () => {

  // 🔹 OBTENER ID DE LA URL
  const { id } = useParams();

  // 🔹 BUSCAR EN EL JSON
  const data = documentos[id];

  // 🔹 SCROLL AL INICIO
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  // 🔴 VALIDACIÓN
  if (!data) {
    return (
      <h2 style={{ textAlign: "center", marginTop: "50px" }}>
        Documento no encontrado
      </h2>
    );
  }

  return (
    <div
      className="container-full-width cinterno-bg"
      style={{
        backgroundImage: `url(${data.background})`,
        backgroundSize: "30%",
        backgroundPosition: "center",
        backgroundRepeat: "repeat",
        width: "100%",
        minHeight: "100vh"
      }}
    >

      {/* 🔹 TÍTULO */}
      
      <h3
        className='title'
        style={{
          color: 'white',
          fontWeight: 'bold',
          textAlign: 'center'
        }}
      >
        {/* 🔹 AQUÍ YA TOMA EL TÍTULO DEL JSON */}
        {data.titulo}
      </h3>

      {/* 🔹 CONTENIDO */}
      <div className="pdf-section">

        {data.pdfs?.map((item) => (
          <div className="pdf-block" key={item.id}>

            <div className="cuadro-text">
              <h4>{item.tituloTexto}</h4>

              <p
                dangerouslySetInnerHTML={{
                  __html: item.descripcion
                }}
              />

              <div className="pdf-viewer-container">

                <h4 className="pdf-viewer-title">
                  {item.tituloPdf}
                </h4>

                <iframe
                  src={item.url}
                  title={item.tituloPdf}
                />

              </div>
            </div>

          </div>
        ))}

      </div>

    </div>
  );
};

export default DocumentoDinamico;